import { PermissionEnum } from '@api/enum';
import { ClientInstallationStatusEnum } from '@api/enum/client-installation.enum';
import { IBusinessDevelopmentUser } from '@api/models';
import NotificationBadge from '@components/NotificationBadge/NotificationBadge';
import useAuthPermission from '@hooks/use-auth-permission';
import { Table } from '@hyperflake/react-ui-library';
import { Chip } from '@library/chip';
import { Tooltip } from '@library/tooltip';
import { TRootState } from '@store/index';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

type Props = {
    data: any[] | undefined;
    isLoading: boolean;
};

const ClientInstallationList = ({ data, isLoading }: Props) => {
    const { hasPermission } = useAuthPermission();
    const navigate = useNavigate();
    const { info: user } = useSelector((state: TRootState) => state.profile);

    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover
            isLoading={isLoading}
            data={data}
            columns={[
                { header: 'ID' },
                { header: 'Name' },
                { header: 'BD' },
                { header: 'Created At' },
                { header: 'Created By' },
                { header: 'Status' },
            ]}
            renderRow={(row) => (
                <Table.Row
                    key={row._id}
                    onClick={() => {
                        hasPermission(PermissionEnum.CLIENT_INSTALLATION_UPDATE)
                            ? navigate(`/client-installations/${row._id}/details`)
                            : null;
                    }}
                >
                    <Table.Cell>
                        <div className="text-primary">
                            <Link to={`/client-installations/${row._id}/details`}>{row._id}</Link>
                        </div>
                    </Table.Cell>

                    <Table.Cell>
                        <div className="flex items-center ">
                            {row?.name}

                            {row?.siteRecceCount !== 0 && (
                                <Tooltip placement="right" content={`Total Site Recce:${row?.siteRecceCount}`}>
                                    <NotificationBadge count={row?.siteRecceCount} />
                                </Tooltip>
                            )}
                        </div>
                    </Table.Cell>

                    <Table.Cell>{(row.businessDevelopmentUser as IBusinessDevelopmentUser).name}</Table.Cell>

                    <Table.Cell>{moment(row?.createdAt, 'YYYYMMDD').format('DD MMM, YYYY')}</Table.Cell>

                    <Table.Cell>{row?.createdBy?.name || '-'}</Table.Cell>

                    <Table.Cell>
                        {row.status ? (
                            <Chip
                                label={row.status}
                                color={
                                    row.status === ClientInstallationStatusEnum.COMPLETE
                                        ? 'success'
                                        : row.status === ClientInstallationStatusEnum.ON_HOLD
                                        ? 'danger'
                                        : 'warning'
                                }
                                variant="shaded"
                            />
                        ) : (
                            '-'
                        )}
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default ClientInstallationList;
